import React, { lazy } from 'react';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  const scrollToOffer = () => {
    document.getElementById('offer')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const painPoints = ['Dormís… pero te despertás agotada igual', 'Comés igual que antes, pero tu cintura cambió', 'Vivís cansada mentalmente, incluso cuando descansás.', 'Ansiedad, antojos, hinchazón que no ceden'];
  return <section className="bg-gradient-hero min-h-0 md:min-h-screen flex items-start pt-10 pb-12 md:pt-12 md:pb-16 relative overflow-hidden" data-id="element-139" data-mp="2wk8tp28o7sg4">
      <div className="absolute left-[8%] md:left-[20%] top-0 bottom-0 w-px bg-gradient-to-b from-transparent via-gold/15 to-transparent" data-id="element-140" data-mp="2mtxdohbppssv" />
      <div className="absolute right-[8%] md:right-[20%] top-0 bottom-0 w-px bg-gradient-to-b from-transparent via-gold/15 to-transparent" data-id="element-141" data-mp="2rryv6xthpk28" />

      <div className="max-w-[1400px] mx-auto px-5 md:px-8 w-full relative z-10" data-id="element-142" data-mp="3fgi5fiw3o6wy">
        <div className="flex flex-col items-center text-center" data-id="element-143" data-mp="3kauohrtnzg86">
          <p className="uppercase tracking-[0.3em] text-[12px] text-[#C8A870] font-semibold mb-7" data-id="element-144" data-mp="2feqsfh5bt0g4">
            NUEVA ESTRATEGIA · 21 DÍAS
          </p>

          <h1 className="font-display font-semibold leading-[1.08] tracking-tight max-w-4xl text-[#F0E8D8]" data-id="element-145" data-mp="2bbu5xfco0k6w">
            <span className="block text-[40px] md:text-6xl" data-id="element-146" data-mp="2p766429lb2v7">
              Volvé a sentirte
            </span>
            <span className="block italic text-gradient-gold text-[38px] md:text-6xl my-1" data-id="element-147" data-mp="2z399tck3b9k9">
              liviana,
            </span>
            <span className="block text-[36px] md:text-5xl" data-id="element-148" data-mp="2u3d6zgn4po6a">
              descansá mejor y recuperá tu energía.
            </span>
          </h1>

          
          <p className="mt-7 uppercase tracking-[0.18em] text-[12px] md:text-[13px] text-[#C8A870] font-semibold leading-[2]" style={{
          paddingRight: "0px",
          width: "310px",
          height: "42px",
          fontWeight: "500",
          textAlign: "center"
        }} data-id="element-149" data-mp="33536l9r5ztf5">
            ✦ Más energía&nbsp;&nbsp;&nbsp;✦ Menos hinchazón &nbsp;✦ Hábitos
            simples
          </p>

          <div className="relative mt-12 mb-10 w-full max-w-[19rem]" data-id="element-150" data-mp="3dsegxgbumky2">
            <div className="absolute inset-0 -z-10 flex items-center justify-center pointer-events-none" data-id="element-151" data-mp="3dso3sv1lkbzj">
              <div className="w-[75%] h-[75%] rounded-full bg-gold/10 blur-[80px]" data-id="element-152" data-mp="3itlobea2xi47" />
            </div>

            <div className="relative text-center" data-id="element-153" data-mp="3mqrgd1ultyf7">
              <img src="https://cdn.shopify.com/s/files/1/0730/1614/8145/files/ebook_430x.webp?v=1780543244" alt="Protocolo H.E.R." width="340" height="456" loading="eager" fetchPriority="high" decoding="async" className="w-full max-w-[340px] mx-auto block rounded-[4px] shadow-[0_25px_60px_rgba(0,0,0,0.45)]" data-id="element-154" data-mp="3rr5risri5ohg" />
            </div>
          </div>

          <div className="max-w-md" data-id="element-155" data-mp="adiep2zepjd8">
            <p className="font-display italic md:text-[26px] text-[23px] text-[#F0E8D8]" data-id="element-156" data-mp="edst9419li3p">
              21 días para recorrer H.E.R. paso a paso.
            </p>
          </div>

          <section className="w-full max-w-[500px] mx-auto mt-12 overflow-hidden" aria-label="Biblioteca H.E.R." data-id="element-157" data-mp="23uel341bjcm1">
            <p className="text-center tracking-[0.22em] uppercase text-[#c9a96e] mb-3 text-[13px]" data-id="element-158" data-mp="1yutnawxvxaaw">
              Biblioteca Digital H.E.R.
            </p>

            <h2 className="text-center font-serif m-0 text-[32px] leading-[1.08]" data-id="element-159" data-mp="1uvubqthnefah">
              <em className="text-[#c9a96e] italic" data-id="element-160" data-mp="1pw7ywl5qf127">
                Todo lo que incluye H.E.R.
              </em>
            </h2>

            <p className="text-center text-[#f5f0e8]/55 mt-4 text-[13px] tracking-[0.06em]" data-id="element-161" data-mp="2ijatj27aern6">
              Deslizá para ver todo lo incluido →
            </p>

            <div className="relative w-full overflow-hidden mt-5" data-id="element-162" data-mp="2dr17hx9ambq6">
              <div className="flex gap-4 overflow-x-auto snap-x snap-mandatory px-[26px] pb-2 scrollbar-hide" data-id="element-163" data-mp="28uaszed4zo6v">
                {[{
                module: 'tracker',
                title: 'Tracker Premium',
                benefit: '✓ Visualizá tu progreso día a día',
                img: 'https://cdn.shopify.com/s/files/1/0730/1614/8145/files/v5gVLGm07qY3WP7hCr5Mp_430x.jpg?v=1780543245',
                pos: 'object-[center_18%]',
                alt: 'Tracker Premium H.E.R.'
              }, {
                module: 'noche',
                title: 'Noche en Calma',
                benefit: '✓ Dormí mejor sin complicarte',
                img: 'https://cdn.shopify.com/s/files/1/0730/1614/8145/files/qushb3WzLl3BYpA9n1eL_430x.jpg?v=1780543244',
                pos: 'object-[center_42%]',
                alt: 'Noche en Calma'
              }, {
                module: 'movement',
                title: 'H.E.R. Movement',
                benefit: '✓ Rutinas cortas que sí podés sostener',
                img: 'https://cdn.shopify.com/s/files/1/0730/1614/8145/files/S8SNVUZHdzf8t092yIlAK_430x.jpg?v=1780543245',
                pos: 'object-[center_34%]',
                alt: 'H.E.R. Movement'
              }, {
                module: 'organizacion',
                title: 'Organización Inteligente',
                benefit: '✓ Compras y planificación sin estrés',
                img: 'https://cdn.shopify.com/s/files/1/0730/1614/8145/files/1I1NNttJTHz_ql3yYujuX_430x.jpg?v=1780543245',
                pos: 'object-[center_18%]',
                alt: 'Organización Inteligente'
              }, {
                module: 'recetario',
                title: 'Recetario H.E.R.',
                benefit: '✓ Comidas simples para 21 días',
                img: 'https://cdn.shopify.com/s/files/1/0730/1614/8145/files/sOWIBzOpm0inWncyzKYoM_430x.jpg?v=1780543245',
                pos: 'object-[center_30%]',
                alt: 'Recetario H.E.R.'
              }].map(item => <article key={item.module} className="shrink-0 basis-[72%] snap-center border border-[#c9a96e]/20 rounded-[18px] bg-[#141210] overflow-hidden" data-id="element-164" data-mp="3nv9s6jcl5mjy">
                    <div className="h-[220px] overflow-hidden bg-[#090807]" data-id="element-165" data-mp="182ar2n07sk9i">
                      <img src={item.img} alt={item.alt} loading="lazy" decoding="async" className={`w-full h-full object-cover ${item.pos}`} data-id="element-166" data-mp="13497m0yvmixi" />
                    </div>

                    <div className="px-[18px] py-4" data-id="element-167" data-mp="1f6so66mcxsnr">
                      <h3 className="font-serif text-[22px] leading-[1.08] text-[#f5f0e8] text-center" data-id="element-168" data-mp="1f5ippgbleigl">
                        {item.title}
                      </h3>

                      <p className="mt-3 text-center text-[15px] leading-snug text-[#c9a96e] font-medium" data-id="element-169" data-mp="1p4gkv23ixa8k">
                        {item.benefit}
                      </p>
                    </div>
                  </article>)}
              </div>
            </div>

            <div className="text-center max-w-[350px] mx-auto mt-6" data-id="element-170" data-mp="11fx9gdp6ghc9">
              

              <p className="mt-1 text-[#f5f0e8]/75 font-[500] text-[15px]" data-id="element-171" data-mp="11e42syekdx49">
                
              </p>
            </div>
          </section>

          <div className="pt-10 flex flex-col items-center w-full max-w-md space-y-4" style={{
          paddingTop: "0px"
        }} data-id="element-172" data-mp="8q8bk97rkxev">
            <CTAButton section="hero" onClick={scrollToOffer} data-id="element-173" data-mp="do9soolmqmnp">
              Acceder al Protocolo H.E.R.
            </CTAButton>

            <p className="uppercase tracking-[0.14em] md:text-[12px] font-body text-center text-[11px] text-[#C8A870]" data-id="element-174" data-mp="180c2h4jff5y">
              ✦Acceso inmediato&nbsp;✦Garantía 30 días&nbsp;✦Pago seguro&nbsp;✦3
              CUOTAS DE $4.000 mercado pago
            </p>
          </div>

          <div className="mt-14 w-full max-w-xl" data-id="element-175" data-mp="3nhbbqfnn81ci">
            <div className="card-premium p-6 backdrop-blur-sm text-left" data-id="element-176" data-mp="3jeezd6op51h0">
              <p className="text-[11px] tracking-[0.2em] uppercase text-[#C8A870] font-semibold mb-3" data-id="element-177" data-mp="3emwvoavagmsc">
                Una alumna dijo:
              </p>

              <p className="italic text-[#F5EFE4] text-[17px]" data-id="element-178" data-mp="39ntresn4uklf">
                “Por primera vez sentí que estaba siguiendo un plan pensado para
                esta etapa de mi vida.”
              </p>

              <p className="mt-4 text-[15px] text-[#E8DCC8]" data-id="element-179" data-mp="2zrh0g2iz2kud">
                — Laura, 52 · Argentina
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}